"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var React = require("react");
var AutocompleteSizes_1 = require("./AutocompleteSizes");
var styles_1 = require("./styles");
var CDN_URL = 'https://cdn.doordash.com/static/img/consumer/share';
var poweredByGoogleLogo = CDN_URL + "/powered_by_google_on_white.png";
var getBaseTextStyles = function (autocompleteSize) {
    switch (autocompleteSize) {
        case AutocompleteSizes_1.AutocompleteSizes.Small:
            return design_language_1.Text.Styles.Medium14;
        case AutocompleteSizes_1.AutocompleteSizes.Default:
        default:
            return design_language_1.Text.Styles.Medium16;
    }
};
var SuggestionsDropdown = function (_a) {
    var suggestions = _a.suggestions, errorText = _a.errorText, autocompleteSize = _a.autocompleteSize, maxWidth = _a.maxWidth;
    var baseTextStyles = getBaseTextStyles(autocompleteSize);
    return (React.createElement(styles_1.SuggestionsList, { autocompleteSize: autocompleteSize, maxWidth: maxWidth },
        suggestions &&
            !errorText &&
            (suggestions || []).map(function (suggestion) { return (React.createElement(styles_1.SuggestionHover, __assign({ active: suggestion.active }, suggestion.props, { styles: baseTextStyles }), suggestion.description)); }),
        errorText && (React.createElement(styles_1.Suggestion, { styles: baseTextStyles }, errorText)),
        React.createElement(styles_1.Suggestion, { styles: design_language_1.Text.Styles.Regular14 },
            React.createElement("img", { src: poweredByGoogleLogo, alt: "Powered by Google" }))));
};
exports["default"] = SuggestionsDropdown;
